//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('offDutyCode', {
//        templateUrl: 'views/components/views/offDutyCode/offDutyCode.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'offDutyCodeService', 'economyService', 'skillsCertificateTypeService', function ($stateParams, stateService, translateService, modalService, offDutyCodeService, economyService, skillsCertificateTypeService) {   

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let offDutyCodeKeyno = $stateParams.offdutycode_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                offDutyCodeKeyno: offDutyCodeKeyno,
//            	edit: {},
//                selectListSalaryTypes: [],
//                selectListColours: [],
//                lockedSave: false,
//                lockedDelete: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            let loadEdit = function () {
//                offDutyCodeService.getEdit({ offdutycode_keyno: offDutyCodeKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            };

//            let loadSalaryTypes = function () {
//                economyService.listSalaryTypes().then(function (list) {
//                    angular.copy(list, vm.model.selectListSalaryTypes);
//                });
//            };

//            let loadColours = function () {
//                skillsCertificateTypeService.listHexColors().then(function (list) {
//                    angular.copy(list, vm.model.selectListColours);
//                });
//            };

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                offDutyCodeService.saveObj(vm.model.edit).then(function (response) {
//                    if (response[0].errorcode !== '0') {
//                    	modalService.show({
//                    		type: 'warning',
//                    		title: translations.error,
//                    		message: response[0].errormessage,
//                    		buttons: [{
//                    			label: translations.ok,
//                    			cssClass: 'btn-warning',
//                    			action: function (dialogItself) {
//                    				dialogItself.close();
//                    				vm.model.lockedSave = false;
//                    			}
//                    		}]
//                    	});
//                    } else {
//                    	vm.model.lockedSave = false;
//                    	stateService.back();
//                    }
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    offDutyCodeService.deleteItem({ offdutycode_keyno: vm.model.edit.offdutycode_keyno }).then(function (response) {
//                        if (response[0].status_no !== '0') {
//                        	modalService.show({
//                        		type: 'warning',
//                        		title: translations.error,
//                                message: response[0].status_message,
//                        		buttons: [{
//                        			label: translations.ok,
//                        			cssClass: 'btn-warning',
//                        			action: function (dialogItself) {
//                        				dialogItself.close();
//                        				vm.model.lockedDelete = false;
//                        			}
//                        		}]
//                        	});
//                        } else {
//                        	vm.model.lockedDelete = false;
//                        	stateService.back();
//                        }
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//                loadSalaryTypes();
//                loadColours();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
